export default "__VITE_ASSET__DmF7Eo5L__"